import React, { useEffect } from 'react';
import { Box, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '../../redux/hooks';
import { subscriptionActions } from '../../redux/subscription/subscriptionSlice';
import { authActions } from '../../redux/auth/authSlice';
import CustomLockMessage from '../../components/CustomLockMessage/CustomLockMessage';
// eslint-disable-next-line max-len
import UpdateBillingDetailsWrapper from '../../components/UpdateBillingDetails/UpdateBillingDetailsWrapper/UpdateBillingDetailsWrapper';

const AccountLockedPage: React.FC = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const userRole = useAppSelector((state) => state.auth.userRole);
  const paymentError = useAppSelector((state) => state.subscription.paymentError);
  const paymentProcessing = useAppSelector((state) => state.subscription.paymentProcessing);
  const [showUpdateBilling, setShowUpdateBilling] = React.useState(false);

  const isAdmin = userRole === 'saas_admin';
  const customTitle = 'Payment Successful!';
  const customDescription = 'Your account is now active. Log in to continue using our services.';

  const handlePayAndUnlock = () => {
    dispatch(subscriptionActions.processPaymentAsync());
  };

  useEffect(() => {
    if (paymentProcessing === 'succeeded') {
      dispatch(authActions.updateAccountStatus('active'));
      navigate(
        `/activation-success?title=${encodeURIComponent(
          customTitle,
        )}&description=${encodeURIComponent(customDescription)}`,
      );
    } else if (paymentProcessing === 'failed') {
      setShowUpdateBilling(true);
    }
  }, [paymentProcessing, dispatch, navigate]);

  if (showUpdateBilling) {
    return <UpdateBillingDetailsWrapper />;
  }

  const lockMessageProps = {
    title: (
      <>
        Account Locked -
        <br />
        Payment Overdue
      </>
    ),
    description:
      'Your account is currently locked due to an overdue payment. ' +
      'Please settle the outstanding balance to unlock your account ' +
      'and restore access to your services.',
    onClick: isAdmin ? handlePayAndUnlock : undefined,
    button: isAdmin ? 'Pay & Unlock' : undefined,
  };

  return (
    <Box display="flex" flexDirection="column" alignItems="center" mb={2}>
      <CustomLockMessage {...lockMessageProps} />
      {paymentError && (
        <Typography
          data-testid="payment-error-message"
          variant="footnoteBold"
          component="p"
          textAlign="center"
          color="error"
        >
          {paymentError}
        </Typography>
      )}
    </Box>
  );
};

export default AccountLockedPage;
